
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';
import AOS from 'aos';


function Layout({ children }) {
  useEffect(() => {
    // Refresh AOS on route change to ensure animations work
    AOS.refresh();
  }, [children]);

  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Skip to main content link for keyboard/screen reader users */}
      <a 
        href="#main-content" 
        className="skip-link position-absolute bg-primary text-white p-2"
        style={{ 
          top: '-100px',
          left: '10px',
          zIndex: 10000,
          transition: 'top 0.2s'
        }}
        onFocus={(e) => e.target.style.top = '10px'}
        onBlur={(e) => e.target.style.top = '-100px'}
      >
        Skip to main content
      </a>
      
      <ScrollToTop />
      <main id="main-content" className="flex-grow-1" tabIndex={-1}>
        {children}
      </main>
      <Footer />
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
